module.exports = __webpack_public_path__ + "static/media/12.cbf61d0d.jpg";